// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__30rQ2","left":"InfoRow_left__2Nqih"};